import React, {useContext} from "react";


export const StationContext = React.createContext<string|null>(null);




export default function useStation() {
    const ctxt = useContext(StationContext)
    if (ctxt === null) {
        throw new Error('Station info not initialized');
    }
    return ctxt;
}
